/** Minimum helper version that installs Arduino libraries before compile/upload. */
export const HELPER_LIBRARY_AUTOINSTALL_VERSION = '0.2.0';

type SemVerParts = [major: number, minor: number, patch: number];

function parseHelperVersion(version: string | undefined): SemVerParts | null {
  if (!version) {
    return null;
  }

  const match = /^(\d+)\.(\d+)\.(\d+)/.exec(version.trim());
  if (!match) {
    return null;
  }

  return [Number(match[1]), Number(match[2]), Number(match[3])];
}

export function isHelperVersionAtLeast(
  version: string | undefined,
  minimum: string,
): boolean {
  const current = parseHelperVersion(version);
  const required = parseHelperVersion(minimum);
  if (!current || !required) {
    return false;
  }

  for (let index = 0; index < 3; index += 1) {
    const currentPart = current[index] ?? 0;
    const requiredPart = required[index] ?? 0;
    if (currentPart > requiredPart) {
      return true;
    }
    if (currentPart < requiredPart) {
      return false;
    }
  }

  return true;
}

export function helperSupportsLibraryAutoinstall(version: string | undefined): boolean {
  return isHelperVersionAtLeast(version, HELPER_LIBRARY_AUTOINSTALL_VERSION);
}
